import React from 'react';
import { Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
// import { useTheme } from '@mui/material/styles';
import Image from '../resources/images/bg.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
  },
  sidebar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.primary.main,
    paddingBottom: theme.spacing(5),
    width: theme.dimensions.sidebarWidth,
    [theme.breakpoints.down('lg')]: {
      width: 'theme.dimensions.sidebarWidthTablet',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      backgroundImage: `url(${Image})`,
      backgroundSize: 'cover',
      height: '100vh',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  },
  paper: {
    '&.MuiPaper-root': {
      backgroundImage: `url(${Image})`,
      backgroundSize: 'cover',
      height: '100vh',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    boxShadow: '-2px 0px 16px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 0, 0, 0),
      backgroundImage: `url(${Image})`,
      backgroundSize: 'cover',
      height: '100vh',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  },
  form: {
    maxWidth: theme.spacing(52),
    padding: theme.spacing(5),
    width: '100%',
    borderRadius: 10,
    background: 'linear-gradient(to bottom, #0066cc 49%, #32327c 93%)',
  },
}));

const LoginLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <main className={classes.root}>
      <Paper className={classes.paper}>
        <form className={classes.form}>
          {children}
        </form>
      </Paper>
    </main>
  );
};

export default LoginLayout;
